import { getScreenWidth } from "../../constants";

const Contact = () => {
  const { isMobile } = getScreenWidth();

  return (
    <div className="text-center">
      <iframe
        style={{
          border: "none",
          width: isMobile ? "100%" : "600px",
          marginTop: isMobile ? "20px" : "80px",
        }}
        height="800px"
        src="https://www.noway-form.com/ja/f/2174981e-ebbf-4ab1-8ab9-4e493f647557/embed"
      />
    </div>
  );
};

export default Contact;
